import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { BeanPergunta } from 'src/bean/BeanPergunta';
import { BeanMonitoria } from '../../../bean/BeanMonitoria';


@Injectable()

export class CadastroFichaMonitoriaService {

    selectedIndex: number = 0;

    constructor(
        private http: HttpClient
    ){ }

    public getHeaders(){

      const tokenString = localStorage.getItem('access_token');

      const headers = {
        'Authorization' : 'Bearer ' + tokenString,
        'Content-Type': 'application/json'
      };

      return headers;
    }

        public createPergXResp(idPergPXR: string, idRespPXR: string, pontuacaoPXR: string, defaultPXR: string, zerarPXR: string, comentarioPXR: string, inativoPXR: string, pontuacaoPXRTrunfo: string):Observable<any> {

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"pergIdCdPergunta\": \""+idPergPXR+"\","+
            "\"respIdCdResposta\": \""+idRespPXR+"\","+
            "\"pereNrPonto\": \""+pontuacaoPXR+"\","+
            "\"pereInRespostaDefault\": \""+defaultPXR+"\","+
            "\"pereInComentario\": \""+comentarioPXR+"\","+
            "\"pereInZerar\": \""+zerarPXR+"\","+
            "\"pereNrPontoExtra\": \""+pontuacaoPXRTrunfo+"\",";
            

            if(inativoPXR == null){
                json += "\"pereDhInativo\": null";
            }else{
                json += "\"pereDhInativo\": \""+inativoPXR+"\"";
            }

            json += "}"

            return this.http.post(environment.urlBackend +  environment.criarPergXResp, json, {headers})
        }

        public updatePergXResp(idPere: string, idPergPXR: string, idRespPXR: string, pontuacaoPXR: string, defaultPXR: string, zerarPXR: string, comentarioPXR: string, inativoPXR: string, pontuacaoPXRTrunfo: string):Observable<any> {

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"pergIdCdPergunta\": \""+idPergPXR+"\","+
            "\"respIdCdResposta\": \""+idRespPXR+"\","+
            "\"pereNrPonto\": \""+pontuacaoPXR+"\","+
            "\"pereInRespostaDefault\": \""+defaultPXR+"\","+
            "\"pereInComentario\": \""+comentarioPXR+"\","+
            "\"pereInZerar\": \""+zerarPXR+"\","+
            "\"pereNrPontoExtra\": \""+pontuacaoPXRTrunfo+"\","; 

            if(inativoPXR == null){
                json += "\"pereDhInativo\": null";
            }else{
                json += "\"pereDhInativo\": \""+inativoPXR+"\"";
            }

            json += "}"

            return this.http.put(environment.urlBackend +  environment.atualizaPergXResp +idPere, json, {headers})
        }

        public listarRespostas(id: string) :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.listarResposta + id, {headers})

        }


        public ajustarTabelas_DuplicacaoDeFormulario() :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.duplicateFormDropList, {headers})

        }



        public criarFormulario_DuplicacaoDeFormulario(id: number) :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.duplicateForm + id, {headers})

        }


        public criarFormulario_DuplicacaoDeFormularioAll(id: number) :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.duplicateFormAll + id, {headers})

        }


        

        public criarGrupoCategoria_DuplicacaoDeFormulario(idFormularioParaCopia: number, idFormularioNovo: number) :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.duplicaCriarGruposCategorias + idFormularioParaCopia +'/'+ idFormularioNovo, {headers})

        }


       
        public  criarCategoria_DuplicacaoDeFormulario(idFormularioNovo: number) :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.duplicaCriarCategorias + idFormularioNovo, {headers})

        }

        
        public  criarPergunta_DuplicacaoDeFormulario(idFormularioNovo: number) :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.duplicateCriarPerguntas + idFormularioNovo, {headers})

        }
        

        
        public criarResposta_DuplicacaoDeFormulario(idFormularioParaCopia: number, idFormularioNovo: number) :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.duplicaCriarRespostas + idFormularioParaCopia +'/'+ idFormularioNovo, {headers})

        }

        


        public criarMotivoParametro_DuplicacaoDeFormulario(idFormularioParaCopia: number, idFormularioNovo: number) :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.duplicaMotivosParametros + idFormularioParaCopia +'/'+ idFormularioNovo , {headers})

        }


        public criarParametro_DuplicacaoDeFormulario(idFormularioParaCopia: number, idFormularioNovo: number) :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.duplicarParametros + idFormularioParaCopia +'/'+ idFormularioNovo , {headers})

        }
        


        public criarVinculoMotivoParametro_DuplicacaoDeFormulario(idFormularioParaCopia: number, idFormularioNovo: number) :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.criarVinculosDeParametrosMotivos + idFormularioParaCopia +'/'+ idFormularioNovo , {headers})

        }


        public criarVinculoPerguntaResposta_DuplicacaoDeFormulario(idFormularioParaCopia: number, idFormularioNovo: number) :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.criarVinculoPerguntaResposta + idFormularioParaCopia +'/'+ idFormularioNovo , {headers})

        }

        
        
        

        










        public listarPerguntas(id: string) :Observable<any>{

            const tokenString = localStorage.getItem('access_token');

            const headers = {
                'Authorization' : 'Bearer ' + tokenString,
                'Content-Type': 'application/json'
                };

            return this.http.get(environment.urlBackend +  environment.listarPerguntas + id, {headers})

        }

    public listarCabecalho(id: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarCabecalho + id, {headers})

    }



    public listarMotivo(id: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarMotivo + id, {headers})

    }




    public listarParametroXMotivo(id: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarParametroXMotivo + id, {headers})

    }




    public listarGrupo(id: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarGrupo + id, {headers})

    }

    public listarCategoria(id: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarCategoria + id, {headers})

    }



    lstFormularioPromisse(idForm : string):Promise<any>{
        return this.listarFormularioEspecifico(idForm).toPromise().then((resposta:any) => resposta);
      }

    public listarFormularioEspecifico(idForm : string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarFormularioEspecifico +"/"+ idForm, {headers})

    }

    public getParametersByIdForm(idForm: string) :Observable<any>{

      const headers = this.getHeaders();

      return this.http.get(`${environment.urlBackend}${environment.criarCabecalho}${environment.listarParametersByForm}${idForm}`, {headers})
    }

    public listaFormulariosPorOperacoes(idOperacao : string, formAtivo:string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarFormulariosOperacao +"/"+ idOperacao +"/"+ formAtivo, {headers})

    }


    public listaTodosFormulariosPorOperacoes(idOperacao : string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarFormulariosOperacaoSemPerguntas +"/"+ idOperacao, {headers})

    }

    public listaCategoriaPergunta(idGrca : string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarCategoriaPorGrupo + idGrca, {headers})

    }

    public listaPerguntaCategoria(idCategoria : string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listaPerguntaCategoria + idCategoria, {headers})

    }

    public listaPergXResp(idForm : string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarPergXResp + idForm, {headers})

    }

    public listaFormulario(idForm : string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarFormulario + idForm, {headers})

    }

    public listaFormularioPossuiMonitoria(idForm : string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarFormularioPossuiMonitoria + idForm, {headers})

    }

    public createFormulario(fichaMonitoria: string, versaoFicha: string, segmento: string, operacao: string, tipoFormulario: string, inativoFicha: string, formDsTipoPontuacao: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"formDsFormulario\": \""+fichaMonitoria+"\","+
            "\"formDsVersao\": \""+versaoFicha+"\","+
            "\"formDsSegmento\": \""+segmento+"\","+
            "\"operIdCdOperacao\": \""+operacao+"\","+
            "\"formInTipo\": \""+tipoFormulario+"\","+
            
            "\"formDsTipoPontuacao\": \""+formDsTipoPontuacao+"\",";            

            if(inativoFicha == null){
                json += "\"formDhInativo\": null";
            }else{
                json += "\"formDhInativo\": \""+inativoFicha+"\"";
            }

            json += "}"

        return this.http.post(environment.urlBackend +  environment.criarFormulario, json, {headers})

    }
    
    public updateFormulario(idFicha: string, fichaMonitoria: string, versaoFicha: string, segmento: string, operacao: string, tipoFormulario: string, inativoFicha: string, formDsTipoPontuacao: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"formDsFormulario\": \""+fichaMonitoria+"\","+
            "\"formDsVersao\": \""+versaoFicha+"\","+
            "\"formDsSegmento\": \""+segmento+"\","+
            "\"operIdCdOperacao\": \""+operacao+"\","+
            "\"formInTipo\": \""+tipoFormulario+"\","+
            "\"formDsTipoPontuacao\": \""+formDsTipoPontuacao+"\",";

            

            if(inativoFicha == null){
                json += "\"formDhInativo\": null";
            }else{
                json += "\"formDhInativo\": \""+inativoFicha+"\"";
            }

            json += "}"

        return this.http.put(environment.urlBackend +  environment.atualizarFormulario+idFicha, json, {headers})

    }

    public createCabecalho(idFicha: string, dsCabecalho: string, inObrigatorio: string, inativoCabecalho: string, paraNrOrdem: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"formIdCdFormulario\": \""+idFicha+"\","+
            "\"paraDsParametro\": \""+dsCabecalho+"\","+
            "\"paraNrOrdem\": \""+paraNrOrdem+"\","+
            "\"paraInObrigatorio\": \""+inObrigatorio+"\",";

            if(inativoCabecalho == null){
                json += "\"paraDhInativo\": null";
            }else{
                json += "\"paraDhInativo\": \""+inativoCabecalho+"\"";
            }

            json += "}"
           
        return this.http.post(environment.urlBackend +  environment.criarCabecalho, json, {headers})

    }


    public createMotivo(idFormulario: string, motivo: string, inativoMotivo: string) :Observable<any>{
        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"formIdCdFormulario\": \""+idFormulario+"\","+
            "\"motiDsMotivo\": \""+motivo+"\","

            if(inativoMotivo == null){
                json += "\"motiDhInativo\": null";
            }else{
                json += "\"motiDhInativo\": \""+inativoMotivo+"\"";
            }

            json += "}"

        return this.http.post(environment.urlBackend +  environment.criarMotivo, json, {headers})

    }




    public createParametroXMotivo(idFormulario : string, idParametro: string, idmotivo: string) :Observable<any>{
        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"formIdCdFormulario\": \""+idFormulario+"\","+
            "\"motiIdCdMotivo\": \""+idmotivo+"\","+
            "\"paraIdCdParametro\": \""+idParametro+"\""

            json += "}"

        return this.http.post(environment.urlBackend +  environment.criarParametroMotivo, json, {headers})

    }


    public removeParametroXMotivo(mopaIdCdMotivoParametro: string) :Observable<any>{
        const tokenString = localStorage.getItem('access_token');

        const options = {
            headers: new HttpHeaders({   'Authorization' : 'Bearer ' + tokenString,
                                         'Content-Type'  : 'application/json'}),
            body: {
                mopaIdCdMotivoParametro: mopaIdCdMotivoParametro
            },
          };


        return this.http.delete(environment.urlBackend + environment.deletarParametroXMotivo + "/" + mopaIdCdMotivoParametro, options);


    }

    public removePergXRep(pereIdCdPerguntaResposta: number) :Observable<any>{
        const tokenString = localStorage.getItem('access_token');

        const options = {
            headers: new HttpHeaders({   'Authorization' : 'Bearer ' + tokenString,
                                         'Content-Type'  : 'application/json'}),
            body: {
                pereIdCdPerguntaResposta: pereIdCdPerguntaResposta
            },
          };

        return this.http.delete (environment.urlBackend + environment.deletarPergXRep + "/" + pereIdCdPerguntaResposta, options);


    }



    public updateCabecalho(idCabecalho: string, idFicha: string, dsCabecalho: string, inObrigatorio: string, inativoCabecalho: string, paraNrOrdem: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"formIdCdFormulario\": \""+idFicha+"\","+
            "\"paraDsParametro\": \""+dsCabecalho+"\","+
            "\"paraNrOrdem\": \""+paraNrOrdem+"\","+
            "\"paraInObrigatorio\": \""+inObrigatorio+"\",";

            if(inativoCabecalho == null){
                json += "\"paraDhInativo\": null";
            }else{
                json += "\"paraDhInativo\": \""+inativoCabecalho+"\"";
            }

            json += "}"

        return this.http.put(environment.urlBackend +  environment.atualizarCabecalho+idCabecalho, json, {headers})

    }



    public updateMotivo(motiIdCdMotivo:string, idFormParametro: string, motiDsMotivo: string, motiDhInativo: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"formIdCdFormulario\": \""+idFormParametro+"\","+
            "\"motiIdCdMotivo\": \""+motiIdCdMotivo+"\","+
            "\"motiDsMotivo\": \""+motiDsMotivo+"\",";

            if(motiDhInativo == null){
                json += "\"motiDhInativo\": null";
            }else{
                json += "\"motiDhInativo\": \""+motiDhInativo+"\"";
            }

            json += "}"

        return this.http.put(environment.urlBackend +  environment.atualizarMotivo + motiIdCdMotivo, json, {headers})

    }

    public updateParametroXMotivo(mopaIdCdMotivoParametro: string, idFormulario: string, idParametro: string, idmotivo: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"paraIdCdParametro\": \""+idParametro+"\",";
            "\"motiIdCdMotivo\": \""+idmotivo+"\"";


            json += "}"

        return this.http.put(environment.urlBackend +  environment.atualizarParameterXMotivo + mopaIdCdMotivoParametro, json, {headers})

    }

    public createGrupoCategoria(idFicha: string, dsGrupo: string, grcaInMapeamento : string, inativoGrupo: string, nrOrdem: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"formIdCdFormulario\": \""+idFicha+"\","+
            "\"grcaDsGrupoCategoria\": \""+dsGrupo+"\","+
            "\"grcaNrOrdem\": \""+nrOrdem+"\","+
            "\"grcaInMapeamento\": \""+grcaInMapeamento+"\",";


            if(inativoGrupo == null){
                json += "\"grcaDhInativo\": null";
            }else{
                json += "\"grcaDhInativo\": \""+inativoGrupo+"\"";
            }

            json += "}"

        return this.http.post(environment.urlBackend +  environment.criarGrupoCategoria, json, {headers})

    }

    public updateGrupoCategoria(idGrupo:string, idFicha: string, dsGrupo: string, grcaInMapeamento : string, inativoGrupo: string, nrOrdem: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"formIdCdFormulario\": \""+idFicha+"\","+
            "\"grcaDsGrupoCategoria\": \""+dsGrupo+"\","+
            "\"grcaNrOrdem\": \""+nrOrdem+"\","+
            "\"grcaInMapeamento\": \""+grcaInMapeamento+"\",";


            if(inativoGrupo == null){
                json += "\"grcaDhInativo\": null";
            }else{
                json += "\"grcaDhInativo\": \""+inativoGrupo+"\"";
            }

            json += "}"

        return this.http.put(environment.urlBackend +  environment.atualizarGrupoCategoria+idGrupo, json, {headers})

    }

    public createCategoria(idGrupo: string, dsCategoria: string, inativoCategoria: string, nrOrdem: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"grcaIdCdGrupoCategoria\": \""+idGrupo+"\","+
            "\"cateNrOrdem\": \""+nrOrdem+"\","+
            "\"cateDsCategoria\": \""+dsCategoria+"\",";

            if(inativoCategoria == null){
                json += "\"cateDhInativo\": null";
            }else{
                json += "\"cateDhInativo\": \""+inativoCategoria+"\"";
            }

            json += "}"

        return this.http.post(environment.urlBackend +  environment.criarCategoria, json, {headers})

    }

    public updateCategoria(idCategoria: string, idGrupo: string, dsCategoria: string, inativoCategoria: string, nrOrdem: string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"grcaIdCdGrupoCategoria\": \""+idGrupo+"\","+
            "\"cateNrOrdem\": \""+nrOrdem+"\","+
            "\"cateDsCategoria\": \""+dsCategoria+"\",";

            if(inativoCategoria == null){
                json += "\"cateDhInativo\": null";
            }else{
                json += "\"cateDhInativo\": \""+inativoCategoria+"\"";
            }

            json += "}"

        return this.http.put(environment.urlBackend +  environment.atualizarCategoria+idCategoria, json, {headers})

    }

    public createPergunta(idGrupo: string, dsPergunta: string, dsObservacao: string, inativoPergunta: string, nrOrdem: string, inExtra: string, pergInRespostasemlista :string) :Observable<any>{

        if(inativoPergunta == null){

        }

        let bean : BeanPergunta = new BeanPergunta(null,idGrupo,dsPergunta,dsObservacao,inativoPergunta,null, nrOrdem, inExtra, pergInRespostasemlista)


        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        let json = JSON.stringify(bean);


        return this.http.post(environment.urlBackend +  environment.criarPergunta, json, {headers})

    }

    public updatePergunta(idPergunta: string, idGrupo: string, dsPergunta: string, dsObservacao: string, inativoPergunta: string, nrOrdem: string, inExtra: string, pergInRespostasemlista :string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        let bean : BeanPergunta = new BeanPergunta(null, idGrupo, dsPergunta, dsObservacao, inativoPergunta, null, nrOrdem, inExtra, pergInRespostasemlista)

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        let json = JSON.stringify(bean);

        return this.http.put(environment.urlBackend +  environment.atualizarPergunta+idPergunta, json, {headers})

    }

    public createResposta(idform: string, dsResposta: string, inativoResposta: string, nrOrdem, respInNaoseaplica:string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

            let json = ""+
            "{"+
            "\"respDsResposta\": \""+dsResposta+"\","+
             "\"respNrOrdem\": \""+nrOrdem+"\","+
            "\"formIdCdFormulario\": \""+idform+"\","+
            "\"respInNaoseaplica\": \""+respInNaoseaplica+"\",";

            if(inativoResposta == null){
                json += "\"respDhInativo\": null";
            }else{
                json += "\"respDhInativo\": \""+inativoResposta+"\"";
            }

            json += "}"

        return this.http.post(environment.urlBackend +  environment.criarResposta, json, {headers})

    }

    public updateResposta(idform: string, idResposta: string, dsResposta: string, inativoResposta: string, nrOrdem, respInNaoseaplica:string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        let json = ""+
            "{"+
            "\"respDsResposta\": \""+dsResposta+"\","+
            "\"respNrOrdem\": \""+nrOrdem+"\","+
            "\"formIdCdFormulario\": \""+idform+"\","+
            "\"respInNaoseaplica\": \""+respInNaoseaplica+"\",";

            if(inativoResposta == null){
                json += "\"respDhInativo\": null";
            }else{
                json += "\"respDhInativo\": \""+inativoResposta+"\"";
            }

            json += "}"

        return this.http.put(environment.urlBackend +  environment.atualizarResposta+idResposta, json, {headers})

    }



    public updateMonitoria(beanMonitoria : BeanMonitoria, idMonitoria : string) :Observable<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        let json = JSON.stringify(beanMonitoria);

        return this.http.put(environment.urlBackend +  environment.updateMonitoria+"/"+idMonitoria, json, {headers})

    }

}
